import { Injectable } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import 'rxjs/Rx';
import { Observable } from 'rxjs/Rx';
import { ConfigService } from '../../config/config.service';
import { SessionService } from './session.service';

@Injectable()
export class PublicDataService {

    constructor(private http: Http, private config: ConfigService, private sessionService: SessionService) { }

    getProductCategories(obj) {
        let headers = new Headers();
        return this.http.get(this.config.getCategories, {
            headers: headers
        })
        .map((data: Response) => data.json())
        .catch(this.handleError);
    }

    getProductList(obj) {
        let headers = new Headers();
        return this.http.post(this.config.getProductList, obj, {
            headers: headers
        })
        .map((data: Response) => data.json())
        .catch(this.handleError);
    }


    getProductDetails(id) {
        let headers = new Headers();
        return this.http.get(this.config.getProductDetails(id), {
            headers: headers
        })
            .map((data: Response) => data.json())
            .catch(this.handleError);
    }

    private handleError(error: any) {
        return Observable.throw(error.json());
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/public-data.service.ts